import type { ProofPoint } from '../domain/landing.types'

type ProofStripProps = { items: ProofPoint[] }

export function ProofStrip({ items }: ProofStripProps) {
  return (
    <section className="proof-strip" id="principios" aria-label="Principios de servicio">
      <div className="proof-strip__inner">
        {items.map((item) => (
          <article className="proof-item" key={item.kicker}>
            <p>{item.kicker}</p>
            <h2>{item.title}</h2>
            <span>{item.description}</span>
          </article>
        ))}
      </div>
    </section>
  )
}
